import { gql } from '@apollo/client';

const getCommentsAndFigures = gql`query getCommentsAndFigures($productId: ID!){
	productComments(productId: $productId){
		versionId
		versionNumber
    pageCount
    isPdf
		comments{
			author
			avatarUrl
			comment
			page
			pageNo
			resourceVersionCommentId
			resourceVersionId
			statusId
			timestamp
			versionCommentNumber
      connectedFigureIds
		  userId
		}
		figures{
			author
			avatarUrl
			connectedCommentId
			created
			figureData
			id
			resourceVersionId
			userId
		}
	}
}`;

export default getCommentsAndFigures;
